function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.87344 1.52079C6.84775 2.16133 4.38516 4.00998 2.88672 6.45266C3.21701 6.61229 3.61819 6.34628 4.18343 6.08027C5.16983 5.6148 6.6527 5.15153 9.12425 6.94479C11.8972 8.95742 13.8545 8.49195 14.6369 6.19333C15.6587 3.18321 17.0397 3.20981 17.831 3.2364C18.0393 3.24529 18.2079 3.2497 18.3186 3.20312C16.5388 2.01065 14.3155 1.29688 12.0435 1.29688C11.3209 1.29688 10.5916 1.36784 9.87344 1.52079Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_3190_8488)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4608 -5.38477L-0.431641 3.21339L6.74342 15.6411L21.6359 7.04288L14.4608 -5.38477Z",
  fill: "currentColor"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7726 6.24926C17.112 8.14662 17.3691 11.5048 16.1012 13.5706C13.909 17.1438 9.18321 15.5257 7.08632 11.9126C6.41912 10.76 6.11322 9.86451 5.25986 9.06654C4.44859 8.30846 3.20948 8.33726 2.49577 8.94686C1.13919 10.0994 1.086 12.6729 1.58915 14.6967C3.03214 20.4931 8.92608 24.0596 14.7292 22.6188C20.53 21.178 24.0521 15.3151 22.6202 9.5143C22.2168 7.88288 21.4942 6.37114 20.6208 5.61086C20.1177 5.16978 19.6544 4.99023 19.2532 4.99023C18.535 4.99023 18.0075 5.56429 17.7726 6.24926Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_3190_8488)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3112 -4.95312L-7.17188 9.75952L6.82813 34.0083L32.3112 19.2956L18.3112 -4.95312Z",
  fill: "currentColor"
}));

var SvgMambu = function SvgMambu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3190_8488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 17,
    height: 8
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3190_8488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 22,
    height: 19
  }, _ref4), _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMambu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mambu.36a8f303.svg";
export { ForwardRef as ReactComponent };